import React, { useEffect, useState, useRef } from 'react';
import { Route, Routes, useLocation, useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import * as loginActions from '../store/modules/loginSlice';

import AppRoutes from '../AppRoutes';
import NavMenu from './NavMenu';
import UpdateCompany from './AccountPanels/UpdateCompany';
import Messages, { showToast } from './Common/Messages';

import storage from './libs/storage';

import PathFinder from './PathFinderPanels/PathFinder';
import Educations from "./PathFinderPanels/Educations";
import Guide from "./PathFinderPanels/Guide";
import FAQ from "./PathFinderPanels/FAQ";
import PopUp from './Common/PopUp';
import Document from "./Document";
import Account from './Account';
import Kbot from './Kbot';
import Footer from './Footer';

const TAB_ID_KEY = "kdcTabId";
const ACTIVE_TABS_KEY = "kdcActiveTabs";
const ACTIVE_TAB_TTL = 15000;
const ACTIVE_TAB_HEARTBEAT = 5000;

const parseJson = (value, fallback = null) => {
    try {
        return value ? JSON.parse(value) : fallback;
    } catch {
        return fallback;
    }
};

const getAutoLoginEnabled = () => {
    return parseJson(localStorage.getItem("isAutoLogin"), {})?.isAutoLogin ?? false;
};

const getActiveTabs = () => {
    const now = Date.now();
    const tabs = parseJson(localStorage.getItem(ACTIVE_TABS_KEY), {}) ?? {};
    const activeTabs = {};

    Object.entries(tabs).forEach(([tabId, touchedAt]) => {
        if (now - Number(touchedAt) <= ACTIVE_TAB_TTL) {
            activeTabs[tabId] = touchedAt;
        }
    });

    localStorage.setItem(ACTIVE_TABS_KEY, JSON.stringify(activeTabs));
    return activeTabs;
};

const removeActiveTab = (tabId) => {
    const tabs = getActiveTabs();
    delete tabs[tabId];
    localStorage.setItem(ACTIVE_TABS_KEY, JSON.stringify(tabs));
};

const touchActiveTab = (tabId) => {
    const tabs = getActiveTabs();
    tabs[tabId] = Date.now();
    localStorage.setItem(ACTIVE_TABS_KEY, JSON.stringify(tabs));
};

const registerActiveTab = () => {
    let tabId = sessionStorage.getItem(TAB_ID_KEY);
    if (!tabId) {
        tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem(TAB_ID_KEY, tabId);
    }

    touchActiveTab(tabId);
    const heartbeatId = window.setInterval(() => touchActiveTab(tabId), ACTIVE_TAB_HEARTBEAT);
    const cleanup = () => removeActiveTab(tabId);

    window.addEventListener("pagehide", cleanup);
    return () => {
        window.clearInterval(heartbeatId);
        window.removeEventListener("pagehide", cleanup);
        cleanup();
    };
};

const getStoredLoginSession = () => {
    const hasCurrentTabSession = sessionStorage.getItem(TAB_ID_KEY) !== null;
    const hasActiveTab = Object.keys(getActiveTabs()).length > 0;

    if (!hasCurrentTabSession && !hasActiveTab) {
        localStorage.removeItem("loginsession");
        sessionStorage.removeItem("reduxState");
        return null;
    }

    return parseJson(window.localStorage.getItem("loginsession"));
};

const Main = () => {
    const iframeRef = useRef(null);
    const autoLoginInfo = getAutoLoginEnabled();
    const loginSession = getStoredLoginSession();
    let login = false;
    if (loginSession != null)
        login = true;
    //page
    const location = useLocation();
    const history = useNavigate();
    //redux
    const LoginStates = useSelector(state => state.login);
    const dispatch = useDispatch();
    const LoginActions = bindActionCreators(loginActions, dispatch);
    //State
    const [menuData, setMenuData] = useState([]);
    const [userMenuData, setUserMenuData] = useState([]);
    const [isLogin, setIsLogin] = useState(login);
    const [msgContent, setMsgContent] = useState(null);
    const [msgUserInfoContent, setMsgUserInfoContent] = useState(null);
    const [addMenuData, setAddMenuData] = useState([]);
    const [kbotFrame, setKbotFrame] = useState(false);
    const [kbotUrl, setKbotUrl] = useState('');
    const [nation, setNation] = useState(1);

    useEffect(() => {
        return registerActiveTab();
    }, [])
    useEffect(() => {
        if (loginSession !== null) {
            fetchSessionCheck(loginSession);
        } else if (autoLoginInfo) {
            checkCookie();
        }
        if (loginSession != null) {
            getUserMenu();
        }
        getSiteConfig();   
        getTopMenu();
        if (location.pathname !== '/') {
            if (checkAccess()) {
                history(location.pathname);
            }
        }
        window.localStorage.removeItem("loginStates");
        window.localStorage.removeItem("simpleViewStates");

    }, [])
    useEffect(() => {
        if (loginSession != null) {
            fetchSessionCheck(loginSession);
        } 
        else {
            if (location.pathname.split('/')[1] && ["Manager", "MyPage", "EditCenter"].includes(location.pathname.split('/')[1])) {
                showToast('danger', '로그인 후 이용해주세요.', 3000);
                history("/Login", { state: {pathName:location.pathname} });
            }
        }
    }, [location.pathname]);
    useEffect(() => {
        if (isLogin) {
            getCompanyAndDeptList();
        }
    }, [isLogin]);
    const getTopMenu = () => {
        fetch('datas/menu/menu.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        }).then((response) => response.json())
            .then(menuData => {
                setMenuData(menuData);
            });
    };
    const getUserMenu = () => {
        fetch('datas/oper/user_menu.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        }).then((response) => response.json())
            .then(menuData => {
                setUserMenuData(menuData);
            });
    };
    const getSiteConfig = () => {
        fetch('datas/oper/site_config.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        }).then((response) => response.json())
            .then(config => {
                const url = config.kbotUrl[0].Url
                setKbotUrl(url);
            });
    }
    const checkAccess = () => {
        const direction = location.pathname.split('/');
        for (const route in direction) {
            const menuInfo = menuData.find(item => item.route === route);
            if (!menuInfo) {
                return false;
            } else {
                if (menuInfo.access == undefined) {
                    return true;
                } else {
                    if (loginSession) {
                        return Array.isArray(menuInfo.access)
                            ? menuInfo.access.some(item => LoginStates.userRole.includes(item.value))
                            : false;
                    } else {
                        return false;
                    }
                }
            }
        }

    }

    const checkCookie = () => {
        fetch('api/Login/CookieCheck', { 
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
        .then((data) => {
            if (data.status !== 'OK') return;
            window.localStorage.removeItem("loginsession");
            LoginActions.init();
            const info = data.userInformation;
            history("/Login", { 
                state: {
                    loginType: "cookie", 
                    userId: info.userId ?? '',
                    userName: info.userName ?? '',
                    userPhoneNum: info.userPhoneNum ?? '',
                    otpType:info.userSendOtpType ?? '',
                    pathName: location.pathname || '/'
                } 
            });
        });
    };

    const getCompanyAndDeptList = () => {
        if (isLogin) {
            fetch('api/User/GetCompanyAndDeptListQuery?userId=' + loginSession?.userId, { 
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then((response) => response.json())
                .then((data) => {
                    if (Object.keys(data).length != 0) {
                        let companyList = data.table ?? '', deptList = data.table1 ?? '';
                        let companySeq = 0, companyName = '', companyType = 0, deptDisplay = 'none';
                        companySeq = data.table2[0].setCompanySeq ?? 0;
                        companyName = data.table2[0].setCompanyName;
                        companyType = data.table2[0].companyType;
                        if (data.table2[0].companySeq == 128 || data.table2[0].companySeq == 129 || data.table2[0].companySeq == 130) {
                            deptDisplay = 'block';
                        }
                        setMsgUserInfoContent(companyList !== '' ? (<UpdateCompany companyList={companyList} companySeq={companySeq} companyName={companyName} companyType={companyType} deptList={deptList} deptDisplay={deptDisplay} closePopup={closePopup} />) : null);
                        
                    }
                });
        }
    };

    const fetchSessionCheck = (loginSession) => {
        const body = {
            userId: encodeURI(loginSession.userId),
            sessionID: encodeURI(loginSession.sessionId)
        }
        fetch('api/Login/CheckSession', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            credentials: 'include',
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.status == 'OK') {
                    const info = resultData.userInformation;
                    const result = {
                        userId: info.userId ?? '',
                        userName: info.userName ?? '',
                        sessionId: info.sessionID ?? '',
                        companyName: info.companyName ?? '',
                        companySeq: info.companySeq ?? '',
                        companyType: info.companyType ?? '',
                        devType: info.devType ?? '',
                        logindate: new Date().toISOString().slice(0, 10),
                        admin: info.admin ?? '',
                        userSendOtpType: info.userSendOtpType ?? '',
                        deptName: info.deptName ?? '',
                        kindName: info.kindName ?? '',
                        isEditor: info.isEditor ?? '0',
                        userRole: info.userRole ?? ''
                    };
                    window.localStorage.setItem("loginsession", JSON.stringify({
                        userId: result.userId,
                        sessionId: result.sessionId
                    }));
                    LoginActions.setResultLogin(result);
                    setIsLogin(true);
                } else {
                    LoginActions.init();
                    setIsLogin(false);
                    window.localStorage.removeItem("loginsession");

                    if (resultData.status == 'SessionExpired') {
                        showToast('danger', '세션이 만료되었습니다. 다시 로그인해주세요.', 3000);

                    } else if (resultData.status == 'PasswordExpired') {
                        showToast('danger', '비밀번호 유효기간이 지났습니다. 비밀번호를 변경해주세요.', 3000);
                    } else {
                        showToast('danger', '로그인 계정이 유효하지 않습니다. 영림원에 문의해주세요.', 3000);
                    }
                    history("/Login");
                }
            });
    };

    const closePopup = (loginstates) => {
        document.getElementsByTagName('body')[0].style.overflow = '';
        const result = {
            companyName: loginstates.table[0].companyName,
            companySeq: loginstates.table[0].companySeq,
            companyType: loginstates.table[0].companyType,
            devType: loginstates.table[0].devType,
            deptName: loginstates.table[0].deptName,
            kindName: loginstates.table[0].getKindName
        };
        LoginActions.setLoginInfo(result);
        setMsgUserInfoContent(null);
    };

    const setRoutePath = (length) => {
        let routeList = [], index = length;
        if (menuData == null)
            return null;
        for (let i = 0; i < menuData.length; i++) {
            let element = null;

            if (menuData[i].element == 'pathfinder')
                element = <PathFinder />;
            else if (menuData[i].element == 'education')
                element = <Educations />;
            else if (menuData[i].element == 'faq')
                element = <FAQ />;
            else if (menuData[i].element == 'guide')
                element = <Guide />;

            if (element != null) {
                routeList.push(
                    <Route key={index++} path={`/${menuData[i].route}`} element={element} />
                );
                if (menuData[i].route === "faq") {
                    routeList.push(
                        <Route path={`/${menuData[i].route}/:kind?/:faqID?`} element={<FAQ />} />
                    );
                } else if (menuData[i].element == 'pathfinder') {
                    if (menuData[i].hasSub === false)
                        routeList.push(
                            <Route path={`/document/${menuData[i].route}/:manualId?`} element={<Document />} />
                        );
                }
                if (menuData[i].hasSub) {
                    element = <Document />;
                    routeList.push(
                        menuData[i].submenu.map((sub) => {
                            return (<Route path={`/${menuData[i].route}/${sub.route}`} element={element} />);
                        })
                    );
                    routeList.push(
                        menuData[i].submenu.map((sub) => {
                            return (<Route path={`/${menuData[i].route}/${sub.route}/:manualId`} element={element} />);
                        })
                    );
                }
            }
        }
        for (let i = 0; i < userMenuData.length; i++) {
            let element = <Account />;
            routeList.push(
                <Route key={index++} path={`/MyPage/${userMenuData[i].id}`} element={element} />
            );
        }
        setAddMenuData(routeList);
    };

    useEffect(() => {
        setRoutePath(AppRoutes.length);
    }, [menuData]);

    const showMsgUserInfoValue = (value) => {
        setMsgUserInfoContent(value);
    };

    const clickButtonSetting = (link) => {
        let LoginStates = storage.get('loginStates');
        if (LoginStates === null) return;
        if (msgContent !== null) {
            if (link != null) window.open(link);
            document.getElementsByTagName('body')[0].style = '';
            setMsgContent(null);
        }
        else {
            // 1:1문의 관련페이지 경로 설정
            let node = '', nodepath = '', catagoryName = '';
            let userId = LoginStates.get('userId');
            let companyType = LoginStates.get('companyType');
            if (window.location.href.indexOf('/Tutorial') !== -1) {
                let tutorialTitle = document.querySelector('.tutorial > li[class="current"] > a').textContent;
                let status = document.querySelector('.status > li[class="current"] > p').textContent;
                nodepath = 'Tutorial / ' + tutorialTitle + ' / ' + status;
            } else if (window.location.href.indexOf('/News') !== -1) {
                node = document.querySelectorAll('.path-nav > li');
            } else {
                node = window.document.querySelectorAll('.doc-nav > li');
            }
            // 카테고리명 넘겨주기
            if (window.location.href.substring(window.location.href.lastIndexOf('/') + 1) === '') {
                catagoryName = '';
            } else if (window.location.href.indexOf('/OpenApi') !== -1) {
                catagoryName = 'OpenAPI';
            } else if (window.location.href.indexOf('/Search') !== -1) {
                catagoryName = 'Search';
            } else {
                catagoryName = menuData.find(n => n.path == window.location.href.substring(window.location.href.lastIndexOf('/') + 1)).menuName;
            }
            for (var i = 0; i < node.length; i++) {
                if (i === 0) nodepath = node[i].textContent;
                else nodepath += ' / ' + node[i].textContent;
            }
            if (userId) {
                setMsgContent(
                    companyType != '0' ?
                        <div className="msg-popup quick-qna">
                            <div className="box">
                                <ul>
                                    <li><Link onClick={() => clickButtonSetting()} to={{
                                        pathname: `/MyPage`
                                    }} state={{
                                        current: 'topicWrite',
                                        userId: userId,
                                        nodePath: nodepath,
                                        catagoryName: catagoryName,
                                        locationFrom: 'qna'
                                    }}>이 페이지에 대해 의견이 있으신가요?</Link></li>
                                    <li><Link onClick={() => clickButtonSetting()} to={{
                                        pathname: `/MyPage`,
                                    }} state={{
                                        current: 'topicWrite',
                                        userId: userId,
                                        locationFrom: 'qna'
                                    }} >K-Developers에 궁금한 점이 있으신가요?</Link></li>
                                </ul>
                            </div>
                        </div> :
                        <div className="msg-popup quick-qna">
                            <div className="box">
                                <ul>
                                    <li><Link onClick={() => clickButtonSetting()} to={{
                                        pathname: `/MyPage`,
                                    }} state={{
                                        current: 'topicWrite',
                                        userId: userId,
                                        nodePath: nodepath,
                                        catagoryName: catagoryName,
                                        locationFrom: 'qna'
                                    }}>이 페이지에 대해 의견이 있으신가요?</Link></li>
                                    <li><Link onClick={() => clickButtonSetting('https://erpnewas.ksystem.co.kr/')} to={{}} >개발 관련 문의 A/S 접수 바로가기</Link></li>
                                </ul>
                            </div>
                        </div>
                );
            } else {
                LoginStates.remove('loginStates');
                setIsLogin(false);
            }
        }
    };   
    
    return (
        <>
            <div className='wrapper' style={kbotFrame ? { width: 'calc(100% - 400px)' } : {}}>
                <div className="frame">
                    {!location.pathname.includes('/EditCenter') && !location.pathname.includes('/Manager') ? <NavMenu menuData={menuData} setMenuData={setMenuData} setIsLogin={setIsLogin} setKbotFrame={setKbotFrame} kbotUrl={kbotUrl} iframeRef={iframeRef} /> : null}
                    <Routes>
                        {AppRoutes.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index} {...rest} element={element} />;
                        })}
                        {addMenuData}
                    </Routes>
                    {isLogin ? <PopUp content={msgUserInfoContent} setContent={showMsgUserInfoValue} /> : null}
                    <Messages />
                </div>
                <Footer nation={nation} setNation={setNation} />
            </div>
            {isLogin && LoginStates.userRole?.includes('Ylw') ? <Kbot on={kbotFrame ? true : false} kbotUrl={kbotUrl} iframeRef={iframeRef} setKbotFrame={setKbotFrame}/> : null}
        </>
    );
}
export default Main;
